import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

interface LoadingSpinnerProps {
  message?: string;
  size?: number;
  fullHeight?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = "Loading...",
  size = 40,
  fullHeight = false,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: fullHeight ? "100vh" : "200px",
        gap: 3,
        background: fullHeight
          ? "linear-gradient(135deg, #F8F9FA 0%, #E3F2FD 100%)"
          : "transparent",
        position: "relative",
      }}
    >
      {/* Animated background dots for visual interest */}
      {fullHeight && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            opacity: 0.05,
            background: `
              radial-gradient(circle at 20% 20%, #007AFF 0%, transparent 50%),
              radial-gradient(circle at 80% 80%, #5AC8FA 0%, transparent 50%),
              radial-gradient(circle at 40% 70%, #007AFF 0%, transparent 50%)
            `,
            pointerEvents: "none",
          }}
        />
      )}

      {/* Modern spinner */}
      <Box
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress
          size={size}
          thickness={3}
          sx={{
            color: "#007AFF",
            "& .MuiCircularProgress-circle": {
              strokeLinecap: "round",
            },
          }}
        />
      </Box>

      {/* Loading text */}
      {message && (
        <Typography
          variant="body1"
          sx={{
            color: "text.secondary",
            fontWeight: 400,
            letterSpacing: "0.01em",
            textAlign: "center",
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingSpinner;
